module.exports = __webpack_public_path__ + "static/img/p_web@2x.481e69c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/p_web@2x.png
// module id = FW8C
// module chunks = 0